/**
 * 12-column grid wrapper. Takes a `rows` array from the layout descriptor,
 * each row containing an array of `cols` with { span, tile, props }.
 *
 * Rendering is delegated to a tile registry (TILE_COMPONENTS) passed in by
 * the parent — keeps this component layout-only, tile-agnostic.
 */
export default function DashboardGrid({ rows, tileRegistry }) {
  return (
    <div className="dash-grid">
      {rows.map((row, ri) =>
        row.cols.map((col, ci) => {
          const Tile = tileRegistry[col.tile];
          if (!Tile) {
            return (
              <div key={`${ri}-${ci}`} className={`dash-col-span-${col.span || 12}`}>
                <div className="dash-card">
                  <div className="dash-card-error">
                    Unknown tile: "{col.tile}"
                  </div>
                </div>
              </div>
            );
          }
          return (
            <div key={`${ri}-${ci}`} className={`dash-col-span-${col.span || 12}`}>
              <Tile {...(col.props || {})} />
            </div>
          );
        })
      )}
    </div>
  );
}
